<kendo-dialog
  title="Bulk Message"
  (close)="closeModal()"
  [minWidth]="250"
  [width]="600"
>
  <div class="row">
    <div class="col-12">
      <kendo-label [for]="messageArea" text="Message"></kendo-label>
      <kendo-textarea
        #messageArea
        [formField]="messageForm.message"
      ></kendo-textarea>
    </div>
    <div class="col-12">
      <input
        type="checkbox"
        id="excludeCautionEmployees"
        class="k-checkbox"
        [formField]="messageForm.excludeCautionEmployees"
      />
      <label class="k-checkbox-label" for="excludeCautionEmployees">
        Exclude Not for Rehire or Caution employees
      </label>
    </div>
  </div>

  <kendo-dialog-actions [layout]="'start'">
    <button kendoButton (click)="closeModal()">Cancel</button>
    <button
      kendoButton
      [primary]="true"
      [disabled]="!model().message"
      (click)="sendMessage()"
    >
      Send Message
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
